import axios from "axios";
import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Gambar } from "./assets/svg/setup.svg";
import { toast } from "sonner";
import detectLocation from "./libs/detectLocation";

const Leave = () => {
  const [sendData, setSendData] = useState({
    startDate: "",
    endDate: "",
    type: "",
    reason: "",
  });

  const handleChange = (e) => {
    console.log("🚀 ~ Leave ~ sendData:", sendData);
    const { name, value } = e.target;
    setSendData({
      ...sendData,
      [name]: value,
    });
  };

  const [isRequest, setIsRequest] = useState(true);

  const [namaGweh, setNamaGweh] = useState(null);
  const [cookies] = useCookies(["token"]);
  const navigate = useNavigate();

  // Menggunakan useEffect untuk navigasi
  useEffect(() => {
    if (
      !cookies.token ||
      cookies.token === null ||
      cookies.token === undefined
    ) {
      navigate("/login");
    } else {
      try {
        // Pastikan cookies.token adalah string dan valid
        const token = cookies.token;
        if (typeof token === "string" && token) {
          const emailGweh = jwtDecode(token).email;
          setNamaGweh(emailGweh);
        } else {
          navigate("/login");
          throw new Error("Invalid token format");
        }
      } catch (error) {
        console.log("MASUK SINI 3");

        navigate("/login");
        console.error("Invalid tokenmm", error);
      }
    }
  }, [cookies.token, navigate]); // Menambahkan dependencies

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [location, setLocation] = useState("Invalid Location");

  useEffect(() => {
    if (namaGweh !== null) {
      const response = fetch(`${process.env.REACT_APP_SERVER}/api/analysis/${namaGweh}`)
        .then((response) => response.json())
        .then((data) => setData(data))
        .catch((error) => setError(`An error occurred: ${error}`))
        .finally(() => setLoading(false));
    }
    const getLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            
            const isInLocation = detectLocation(latitude, longitude);
            
            // Tentukan lokasi pengguna berdasarkan hasil detectLocation
            const locationRightNow = isInLocation
              ? "In Dhoho TV"
              : "Outside Dhoho TV";

            setLocation(locationRightNow);
            
          },
          (error) => {
            setError(error.message);
          }
        );
      } else {
        setError("Geolocation is not supported by this browser.");
      }
    };

    getLocation();
  }, [namaGweh]);

  if (loading)
    return (
      <div className="relative min-h-svh bg-slate-100 flex flex-col gap-4 px-4 pt-4 pb-28">
        {/* Idendidy */}
        <div className="rounded-xl grid grid-cols-2 px-6 py-4 gap-4  shadow bg-slate-50">
          <div className="flex flex-col gap-1">
            <p className="text-xs">Employee Name</p>
            <p className="text-md font-bold">--</p>
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-xs">Employee ID</p>
            <p className="text-md font-bold">--</p>
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-xs">Job Position</p>
            <p className="text-md font-bold">--</p>
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-xs">Status</p>
            <p className="text-md font-bold">--</p>
          </div>
        </div>
        {/* Counts Attnd */}
        <div className="rounded-xl shadow bg-slate-50 p-2 flex gap-2 justify-evenly">
          <div className="flex flex-col items-center">
            <p className="text-md font-bold">--</p>
            <p className="text-xs font-normal text-gray-400">Avaible Leave</p>
          </div>
          <div className=" h-10   border-s border-gray-400 w-1" />
          <div className="flex items-center flex-col">
            <p className="text-md font-bold">--</p>
            <p className="text-xs font-normal text-gray-400">Used Leave</p>
          </div>
        </div>
        {/* Request n History */}
        <div className="rounded-xl shadow w-full !max-w-full bg-slate-50 p-4 flex flex-col gap-4">
          <div className="flex justify-around">
            <div
              onClick={() => setIsRequest(true)}
              className={`${
                isRequest ? "text-green-600" : "text-gray-400"
              } flex flex-col gap-2 cursor-pointer`}
            >
              <p
                className={
                  isRequest
                    ? "text-lg font-semibold"
                    : "font-semibold text-lg text-gray-400"
                }
              >
                Leave Request
              </p>
              <div
                className={
                  isRequest ? "h-0.5 w-full rounded bg-green-600" : "hidden"
                }
              />
            </div>
            <div
              onClick={() => setIsRequest(false)}
              className={`${
                isRequest ? "text-green-600" : "text-gray-400"
              } flex flex-col gap-2 cursor-pointer`}
            >
              <p
                className={
                  !isRequest
                    ? "text-lg font-semibold text-green-600"
                    : "font-semibold text-lg text-gray-400"
                }
              >
                Leave History
              </p>
              <div
                className={
                  isRequest ? "hidden" : "h-0.5 rounded w-full bg-green-600"
                }
              />
            </div>
          </div>
          <div className="flex flex-col gap-4 !max-w-full">
            {/* <div className="flex flex-col gap-2">
              <p className="text-md font-bold">Duration</p>
              <div className="flex justify-between text-black gap-4 !max-w-full items-center">
                <div className="flex-1 shadow bg-gray-200 font-semibold rounded-lg p-2 text-sm flex  items-center">
                  <input
                    type="date"
                    name=""
                    id=""
                    className=" bg-gray-200 w-full"
                  />
                </div>
                <p className="text-sm font-semibold ">to</p>
                <div className="flex-1 shadow bg-gray-200 font-semibold rounded-lg p-2 text-sm flex  items-center">
                  <input type="date" name="" id="" className=" bg-gray-200" />
                </div>
              </div>
            </div> */}
            <div className="flex flex-col gap-2">
              <p className="text-md font-bold">Type of leave</p>
              <select
                value={sendData.type}
                onChange={handleChange}
                placeholder="Annual Leave"
                className="bg-gray-200 placeholder:px-3 rounded-lg  font-normal shadow w-full p-2 flex justify-between items-center"
              >
                <option value="" disabled className="text-gray-400">
                  Select this option
                </option>
                <option value="sick">Sick</option>
                <option value="permission">Permission</option>
                <option value="dispen">Dispensasi</option>
              </select>
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-md font-bold">Reason (Optional)</p>
              <textarea
                placeholder="Write description here..."
                className="bg-gray-200 rounded-lg h-32 font-normal shadow w-full p-2 flex justify-between items-center"
              ></textarea>
            </div>
            <div className="flex justify-end">
              <button className="bg-green-700  shadow rounded-md text-sm text-white font-semibold px-3 py-2">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    );

  if (error) return <div>Error Bos: {error}</div>;

  const ourData = data.payload.datas;
  console.log("🚀 ~ Leave ~ ourData:", ourData);
  const dataUser = ourData.user.datas;
  console.log("🚀 ~ Leave ~ dataUser:", dataUser);
  const nameUSer = dataUser.name;
  const idUser = `2024204${
    dataUser.id <= 10
      ? `00${dataUser.id}`
      : dataUser.id <= 100
      ? `0${dataUser.id}`
      : `${dataUser.id}`
  }`;
  const jobUser = dataUser.bagian;
  const statusUser = dataUser.posisi;
  const usedLeave = 1;
  const avaibleLeave = 2;

  const handleSubmit = async (e) => {
    e.preventDefault(); // Mencegah refresh halaman
    if (data.payload.datas.isLeaveToday !== undefined) return;

    try {
      const responseAttend = await axios.post(
      `${process.env.REACT_APP_SERVER}/api/attendance/create?is_leave=1`,
        {
          id_user: dataUser.id,
          kehadiran: sendData.type,
          position: location,
          is_acc: 0
        }
      );
      const response = await axios.post(
      `${process.env.REACT_APP_SERVER}/api/leave/create`,
        {
          id_user: dataUser.id,
          id_attendance: responseAttend.data.payload.datas.id,
          type: sendData.type,
          reason: sendData.reason,
          date: responseAttend.data.payload.datas.check_in,
        }
      );
      toast.success("Leave request successfully created!");
      window.location.reload()
    } catch (error) {
      console.error("Error posting data:", error);
      toast.error("Error creating post.");
    }
  };

  const historyLeave =
    data.payload.datas.leaveHistory === undefined
      ? []
      : data.payload.datas.leaveHistory.datas;
  console.log("🚀 ~ Leave ~ historyLeave:", historyLeave);

  return (
    <div className="relative min-h-svh bg-slate-100 flex flex-col gap-4 px-4 pt-4 pb-28">
      {/* Idendidy */}
      <div className="rounded-xl grid grid-cols-2 px-6 py-4 gap-4  shadow bg-slate-50">
        <div className="flex flex-col gap-1">
          <p className="text-xs">Employee Name</p>
          <p className="text-md font-bold">{nameUSer}</p>
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-xs">Employee ID</p>
          <p className="text-md font-bold">{idUser}</p>
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-xs">Job Position</p>
          <p className="text-md font-bold">{jobUser}</p>
        </div>
        <div className="flex flex-col gap-1">
          <p className="text-xs">Status</p>
          <p className="text-md font-bold">{statusUser}</p>
        </div>
      </div>
      {/* Counts Attnd */}
      <div className="rounded-xl shadow bg-slate-50 p-2 flex gap-2 justify-evenly">
        <div className="flex flex-col items-center">
          <p className="text-md font-bold">{avaibleLeave} Day</p>
          <p className="text-xs font-normal text-gray-400">Avaible Leave</p>
        </div>
        <div className=" h-10   border-s border-gray-400 w-1" />
        <div className="flex items-center flex-col">
          <p className="text-md font-bold">{usedLeave} Day</p>
          <p className="text-xs font-normal text-gray-400">Used Leave</p>
        </div>
      </div>
      {/* Request n History */}
      <div className="rounded-xl shadow w-full !max-w-full bg-slate-50 p-4 flex flex-col gap-4">
        <div className="flex justify-around">
          <div
            onClick={() => setIsRequest(true)}
            className={`${
              isRequest ? "text-green-600" : "text-gray-400"
            } flex flex-col gap-2 cursor-pointer`}
          >
            <p
              className={
                isRequest
                  ? "text-lg font-semibold"
                  : "font-semibold text-lg text-gray-400"
              }
            >
              Leave Request
            </p>
            <div
              className={
                isRequest ? "h-0.5 w-full rounded bg-green-600" : "hidden"
              }
            />
          </div>
          <div
            onClick={() => setIsRequest(false)}
            className={`${
              isRequest ? "text-green-600" : "text-gray-400"
            } flex flex-col gap-2 cursor-pointer`}
          >
            <p
              className={
                !isRequest
                  ? "text-lg font-semibold text-green-600"
                  : "font-semibold text-lg text-gray-400"
              }
            >
              Leave History
            </p>
            <div
              className={
                isRequest ? "hidden" : "h-0.5 rounded w-full bg-green-600"
              }
            />
          </div>
        </div>
        {isRequest ? (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col gap-4 !max-w-full"
          >
            {/* <div className="flex flex-col gap-2">
              <p className="text-md font-bold">Duration</p>
              <div className="flex justify-between gap-4 !max-w-full items-center">
                <div className="flex-1 shadow bg-gray-200 font-semibold rounded-lg p-2 text-sm flex  items-center">
                  <input
                    type="date"
                    name="startDate"
                    onChange={handleChange}
                    value={sendData.startDate}
                    id=""
                    className="w-full bg-gray-200"
                  />
                </div>
                <p className="text-sm font-semibold ">to</p>
                <div className="flex-1 shadow bg-gray-200 font-semibold rounded-lg p-2 text-sm flex  items-center">
                  <input
                    type="date"
                    name="endDate"
                    onChange={handleChange}
                    value={sendData.endDate}
                    id=""
                    className="w-full bg-gray-200"
                  />
                </div>
              </div>
            </div> */}
            <div className="flex flex-col gap-2">
              <p className="text-md font-bold">Type of leave</p>
              <select
                name="type"
                value={sendData.type}
                onChange={handleChange}
                placeholder="Annual Leave"
                className="bg-gray-200 placeholder:px-3 rounded-lg  font-normal shadow w-full p-2 flex justify-between items-center"
              >
                <option value="" disabled className="text-gray-400">
                  Select this option
                </option>
                <option value="S">Sick</option>
                <option value="I">Permission</option>
                <option value="H">Dispensasi</option>
              </select>
            </div>
            <div className="flex flex-col gap-2">
              <p className="text-md font-bold">Reason (Optional)</p>
              <textarea
                onChange={handleChange}
                value={sendData.reason}
                name="reason"
                placeholder="Write description here..."
                className="bg-gray-200 rounded-lg h-32 font-normal shadow w-full p-2 flex justify-between items-center"
              ></textarea>
            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                className={` shadow rounded-md text-sm  font-semibold px-3 py-2 ${
                  data.payload.datas.isLeaveToday !== undefined
                    ? "bg-gray-300 text-gray-400"
                    : "bg-green-700 text-white "
                }`}
              >
                {data.payload.datas.isLeaveToday !== undefined
                  ? "You have leave today"
                  : "Submit"}
              </button>
            </div>
          </form>
        ) : historyLeave.length !== 0 ? (
          <div className="grid grid-cols-2 gap-4">
            {historyLeave.map((cb, i) => {
              const theDay = new Date(cb.create_at);
              const thisDay = theDay.getDate();
              const nameDay = theDay.toLocaleDateString("en-GB", {
                weekday: "long",
              });
              return (
                <div
                  key={i}
                  className="p-2 rounded-lg shadow-lg flex flex-col gap-2 bg-slate-50"
                >
                  <p className="text-md border-b border-gray-400 font-semibold">
                    {cb.type === "S"
                      ? "Sick"
                      : cb.type === "I"
                      ? "Permission"
                      : "Dispenasi"}
                  </p>
                  <div className="flex items-center justify-center py-2 bg-green-700 rounded-lg">
                    <div className="w-full justify-center items-center flex flex-col text-white">
                      <p className="text-2xl font-bold ">{thisDay}</p>
                      <p className="text-sm font-light">{nameDay}</p>
                    </div>
                    {/* <div className="ps-6 pe-4 py-2 justify-center items-center flex flex-col text-white">
                  <p className="text-2xl font-bold ">23</p>
                  <p className="text-sm font-light">Wed</p>
                </div>
                <p className="text-white font-light text-xs h-full flex items-center bg-green-700 pb-5">
                  to
                </p>
                <div className="pe-6 ps-4 py-2 justify-center items-center flex flex-col text-white">
                  <p className="text-2xl font-bold ">24</p>
                  <p className="text-sm font-light">Wed</p>
                </div> */}
                  </div>
                  <p className="text-xs pt-1 px-2 pb-2 bg-gray-300 h-full text-gray-600 rounded-md">
                    {cb.reason}
                  </p>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="w-full h-32 flex items-center px-6 gap-2   justify-evenly ">
            <Gambar height={100} width={100} />
            <div className=" max-w-52">
              <p className="text-sm">
                Wah kamu rajin sekali sampai belum cuti, Jangan lupa istirahat ya!
              </p>
              
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Leave;
